import React, { createContext, useContext, useState, useEffect } from 'react';
import { EN, AR } from '../data/translations';

const LanguageContext = createContext({ lang:'en', t:k=>EN[k]||k, isRTL:false, toggleLanguage:()=>{} });

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem('ic_language') || 'en'; } catch { return 'en'; }
  });

  const t    = (key) => (lang === 'ar' ? AR : EN)[key] || EN[key] || key;
  const isRTL = lang === 'ar';

  function toggleLanguage() {
    const next = lang === 'en' ? 'ar' : 'en';
    setLang(next);
    try { localStorage.setItem('ic_language', next); } catch {}
  }

  useEffect(() => {
    document.documentElement.dir  = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, t, isRTL, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);

// Standalone toggle button — hidden until Arabic support is re-enabled
export function LangToggleBtn({ style = {} }) {
  return null;
}
